interface UseConvert {
  convertDateToApiFormat: (value: string) => string;
  convertDateToLocalFormat: (value: string) => string;
  convertToFloat: (value: string | number, isFormatDot?: boolean) => string;
  convertToPercentage: (value: string) => string;
}

export const useConvert = (): UseConvert => {
  const replaceSeparator = (value: string, isFormatDot = true): string => {
    return isFormatDot ? value.replace(',', '.') : value.replace('.', ',');
  };

  const collectFloatNumber = (value: string): string => {
    const splittedValue = value.split('.');

    return `${splittedValue[0]}.${splittedValue[1].slice(0, 2)}`;
  };

  const convertDateToApiFormat = (inputDate: string): string => {
    if (!inputDate) return '';

    const [day, month, year] = inputDate.split('-');
    const isoDateString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

    return isoDateString;
  };

  const convertDateToLocalFormat = (inputDate: string): string => {
    if (!inputDate) return '';

    const [year, month, day] = inputDate.split('-');
    const isoDateString = `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;

    return isoDateString;
  };

  const convertToFloat = (value: string | number, isFormatDot = true): string => {
    const formattedValue = String(value);
    const parsedValue = parseFloat(replaceSeparator(formattedValue)) || 0;

    return replaceSeparator(parsedValue.toFixed(2), isFormatDot);
  };

  const convertToPercentage = (value: string): string => {
    if (!value || isNaN(parseFloat(value))) {
      return '0.00';
    }

    let formattedValue = value.toString().replace(',', '.');
    const parsedValue = parseFloat(formattedValue);

    // Collecting a float number
    if (parsedValue <= 100) {
      return collectFloatNumber(parsedValue.toFixed(2).toString());
    }

    // If the number is without a dot, add a dot and 0 to the right
    if (!formattedValue.includes('.')) {
      formattedValue = parsedValue.toFixed(2);
    }

    // While the number is greater than 100, move the dot to the left
    while (parseFloat(formattedValue) > 100) {
      const dotIndex = formattedValue.indexOf('.');

      // If there is a point and it is not the first one, move it to the left
      if (dotIndex > 0) {
        formattedValue =
          formattedValue.slice(0, dotIndex - 1) +
          '.' +
          formattedValue.slice(dotIndex - 1, dotIndex) +
          formattedValue.slice(dotIndex + 1);
      } else {
        // If the dot is at the beginning or missing, we end the cycle
        break;
      }
    }

    // Collecting a float number
    return collectFloatNumber(formattedValue);
  };

  return { convertDateToApiFormat, convertDateToLocalFormat, convertToFloat, convertToPercentage };
};
